import React from 'react';

type Props = {
    url: string
}

function AppStoreMarkup({url}: Props) {
    return (<>
{`<a href="${url}">
    <img alt='Download on the App Store'
         src='https://ngage-storage.ams3.digitaloceanspaces.com/assets/app-badges/apple-app-store-badge.png'
         height=95
    />
</a>`}
    </>);
}

export default AppStoreMarkup;